import { Button } from '@mantine/core';
import { useCallback, useState } from 'react';
import { formDefaults, forms } from '../../_definitions/forms';
import Form from '../Form/Form';
import { Actions, Wrapper } from './SignupForm.style';

export type SignupFormProps = {
  onCta: (value: Json) => void;
  onCancel: () => void;
};

export function SignupForm(props: SignupFormProps) {
  const [value, setValue] = useState<Json>({});

  function onChange(_change: Json, allData: Json) {
    setValue(allData);
  }

  const onClick = useCallback(() => {
    props.onCta(value);
  }, [value]);

  return (
    <Wrapper className='SignupForm-wrapper' data-testid='SignupForm-wrapper'>
      <Form
        config={forms.signup as any}
        allOptions={{}}
        data={formDefaults.signup}
        onChange={onChange}
      />
      <Actions>
        <Button
          variant='gradient'
          gradient={{ deg: 45, from: 'pink', to: 'yellow' }}
          onClick={onClick}
        >
          Save
        </Button>
      </Actions>
    </Wrapper>
  );
}

export default SignupForm;
